import React, { Component } from 'react';
import { Map } from 'osm-ui-react';
import PropTypes from 'prop-types';
import DoorNode from './DoorNode';
import { connect } from 'react-redux';
import { newDoorModesAlong } from '../modes';
const possibleDoorTagKeys = [
  'addr:housenumber',
  'addr:street',
  'door',
  'entrance',
];

function getNodeAttributes(node) {
  let nodeProps = {
    latlng: [node.lat, node.lon],
    version: node.version,
  };
  const possibleDoor =
    node.tag && node.tag.some((t) => possibleDoorTagKeys.includes(t.k));

  if (possibleDoor) {
    const reducer = (accumulator, tag) => {
      return { ...accumulator, [`${tag.k}`]: tag.v };
    };
    const tags = node.tag.filter((t) => !t.k.startsWith('addr'));
    const address = node.tag.filter((t) => t.k.startsWith('addr'));

    nodeProps = {
      ...nodeProps,
      tags: tags.reduce(reducer, {}),
      address: address.reduce(reducer, {}),
    };
  }
  return {
    nodeId: node.id, // `node/${node.id}`
    nodeProps: nodeProps,
    nodeCoords: nodeProps.latlng,
    possibleDoor: possibleDoor,
  };
}

class SelectedPoly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sendPoint: false,
      savedPoint: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.mode === 'newDoor' &&
      this.props.marker !== prevProps.marker &&
      this.props.marker === false
    ) {
      this.setState({ savedPoint: null, sendPoint: true });
    }
    if (this.props.mode !== prevProps.mode && this.props.mode === 'newDoor') {
      if (this.props.markerOnNewDoor) {
        this.setState({ savedPoint: this.props.currentDoorLatlng });
      }
      // else if (this.props.markerOnAlterDoor) {
      //   this.setState({ savedPoint: this.props.currentDoorLatlng });
      // }
    }
  }

  // Map.Along calls handlePoint() when clicked, with params :
  // coords:
  // onExistingNode:
  // index:
  // hashed:
  // nodeOfWayIndex:
  // otherNodeIndex:
  // isOtherNodeAlongWay:
  handlePoint = (params) => {
    const {
      coords,
      onExistingNode,
      index,
      hashed,
      nodeOfWayIndex,
      otherNodeIndex,
      isOtherNodeAlongWay,
    } = params;
    // console.log(params);
    this.setState({
      savedPoint: [coords.lat, coords.lng],
      sendPoint: false,
    });
    // new node along a way
    // add it to way
    if (!onExistingNode) {
      // console.log('on a new node, along a way');
      const latlng = [coords.lat, coords.lng];
      this.props.newDoorLatlng(latlng);
      const wayId = this.props.selectedPoly.poly.refByPositionsHash[hashed];
      const wayVersion = this.getWayVersion(wayId);
      this.props.newDoorSegment(wayId, index, wayVersion);

      this.props.setMarkerOnNewNode();
    }
    // existing node of way
    // modify it
    else if (nodeOfWayIndex !== undefined) {
      // console.log('existing node of a way');
      const resultNode = this.props.selectedPoly.poly.nodes.find(
        (node) =>
          `node/${node.id}` ===
          this.props.selectedPoly.poly.nodesListByPositionsHash[hashed][
            nodeOfWayIndex
          ]
      );
      const { nodeId, nodeProps, possibleDoor } = getNodeAttributes(resultNode);
      this.mouseOnPoint(nodeId, nodeProps, possibleDoor);

      this.props.setMarkerOnAlterNode();
    }
    // existing other node along way
    // modify it and add it to way
    else if (otherNodeIndex !== undefined && isOtherNodeAlongWay) {
      // console.log('existing other node (maybe along way)');
      const resultNode = this.props.selectedPoly.poly.moreNodes[otherNodeIndex];
      const { nodeId, nodeProps, possibleDoor } = getNodeAttributes(resultNode);
      this.mouseOnPoint(nodeId, nodeProps, possibleDoor);
      const wayId = this.props.selectedPoly.poly.refByPositionsHash[hashed];
      const wayVersion = this.getWayVersion(wayId);
      this.props.alterDoorSegment(wayId, index, wayVersion);
      this.props.setMarkerOnAlterJoinNode();
    }
    // existing other node, not along way
    // don't do anything (a door or entrance must be on a way)
    else if (otherNodeIndex !== undefined && !isOtherNodeAlongWay) {
      console.info('existing other node, not along way');
      console.info('Balluchon cannot handle this kind of point point for now.');
    }
  };

  getWayVersion = (wayId) => {
    let wayVersion = undefined;
    if (this.props.selectedPoly.id.startsWith('way')) {
      wayVersion = this.props.selectedPoly.poly.way.way[0]['$'].version;
    } else if (this.props.selectedPoly.id.startsWith('rel')) {
      const way = this.props.selectedPoly.poly.ways.find(
        (w) => `way/${w['$'].id}` === wayId
      );
      wayVersion = way['$'].version;
    }
    return wayVersion;
  };

  mouseOnPoint = (nodeId, nodeProps, possibleDoor) => {
    this.props.selectAlterDoor(
      this.props.selectedPoly.id,
      `node/${nodeId}`,
      nodeProps
    );
  };

  render() {
    const { mousePos, mapref } = this.props;
    const { sendPoint, savedPoint } = this.state;
    const positions = this.props.selectedPoly.poly
      ? this.props.selectedPoly.poly.positions
      : null;
    const nodesPositions = this.props.selectedPoly.poly
      ? [
          ...this.props.selectedPoly.poly.nodes,
          ...this.props.selectedPoly.poly.moreNodes,
        ]
      : null;

    let otherNodesPositions;
    if (
      this.props.selectedPoly &&
      this.props.selectedPoly.poly &&
      this.props.selectedPoly.poly.moreNodes
    ) {
      otherNodesPositions = this.props.selectedPoly.poly.moreNodes.map(
        (node, i) => [parseFloat(node.lat), parseFloat(node.lon)]
      );
    }

    return (
      <div>
        {this.props.mode !== 'trip' && positions && (
          <>
            {newDoorModesAlong.includes(this.props.mode) && (
              <Map.Along
                map={mapref.leafletElement}
                showPoint={true}
                waysPositions={positions}
                otherNodesPositions={
                  otherNodesPositions ? otherNodesPositions : undefined
                }
                allowInside={this.props.newDoorOptions.allowInside}
                mousePos={mousePos}
                pointColor={this.props.marker === true ? '#001199' : '#990011'}
                forcePosition={
                  this.props.marker === false ? savedPoint : undefined
                }
                magnetic={this.props.newDoorOptions.magneticDistance >= 0}
                magneticDistance={this.props.newDoorOptions.magneticDistance}
                onlyAlongNodes={true}
                sendPoint={sendPoint}
                handlePoint={this.handlePoint}
              />
            )}

            {nodesPositions.map((node) => {
              const {
                nodeId,
                // nodeProps,
                nodeCoords,
                possibleDoor,
              } = getNodeAttributes(node);

              const selected =
                !this.props.marker &&
                (this.props.markerOnAlterDoor ||
                  this.props.markerOnAlterJoinDoor) &&
                this.props.selectedAlterDoorNodeId &&
                this.props.selectedAlterDoorNodeId === `node/${nodeId}`;

              return (
                <DoorNode
                  key={nodeId}
                  possibleDoor={possibleDoor}
                  selected={selected}
                  center={nodeCoords}
                />
              );
            })}

            <Map.Polygon
              positions={positions}
              color={'#009911'}
              fillColor={'#298011'}
              stroke={true}
            />
          </>
        )}
      </div>
    );
  }
}

SelectedPoly.propTypes = {
  mapref: PropTypes.oneOfType([
    // Either a function
    PropTypes.func,
    // Or the instance of a DOM native element (see the note about SSR)
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  mousePos: PropTypes.array,
};

const mapState = (state, ownprops) => ({
  mode: state.mode,
  currentDoorLatlng: state.newDoor.currentProps.latlng,
  marker: state.newDoorMarker,
  markerOnNewDoor: state.markerOn === 'new',
  markerOnAlterDoor: state.markerOn === 'alter',
  markerOnAlterJoinDoor: state.markerOn === 'alterjoin',

  selectedPoly: state.selectedPoly,
  newDoorOptions: state.newDoorOptions,
  selectedAlterDoorNodeId: state.newAlterDoor.currentNodeId,
});

const mapDispatch = (dispatch) => ({
  newDoorLatlng: (latlng) => dispatch.newDoor.newDoorLatlng(latlng),
  newDoorSegment: (wayId, index, wayVersion) =>
    dispatch.newDoor.newDoorSegment({ wayId, index, wayVersion }),
  alterDoorSegment: (wayId, index, wayVersion) =>
    dispatch.newAlterDoor.alterDoorSegment({ wayId, index, wayVersion }),

  setMarkerOnNewNode: (_) => dispatch.markerOn.setMarkerOnNewNode(),
  setMarkerOnAlterNode: (_) => dispatch.markerOn.setMarkerOnAlterNode(),
  setMarkerOnAlterJoinNode: (_) => dispatch.markerOn.setMarkerOnAlterJoinNode(),

  selectAlterDoor: (elementId, nodeId, nodeProps) =>
    dispatch.newAlterDoor.alterDoor({ elementId, nodeId, nodeProps }),
});

export default connect(mapState, mapDispatch)(SelectedPoly);
